import React from 'react';
import moment from 'moment';

import { PopoverMenu } from 'src/components/basic';
import { MCDatePicker } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import { lang, scssVariables } from 'src/helpers';

const gfg_Run = (date, reDate = false, format = 'MM/DD/YYYY') => {
  if (!date || date === '' || date === null) {
    if (!reDate) return '';
    date = moment();
  }
  if (typeof date === 'string' || typeof date === 'number') date = moment(date);
  if (reDate) {
    return date;
  }
  return date.format(format);
};

const DatePickerField = React.memo(
  ({
    template = '',
    value,
    placeholder = 'MM/DD/YYYY',
    format = 'MM/DD/YYYY',
    name,
    invalid,
    onChange,
    label,
    placement = 'top-center',
    rightIcon,
    noIcon = false,
    maxDate,
    minDate,
    styleBox = {},
    close = true,
    defaultCalendar = null,
    ...props
  }) => {
    return (
      <div
        className={'mc-text-field-group mc-datepicker-field-group template-' + template}
        {...props}
      >
        {label && <label>{lang.t(label)}</label>}
        <div className={'mc-input-box-cover'} style={{ position: 'relative', ...styleBox }}>
          <PopoverMenu
            placement={placement}
            triggerOffset={10}
            style={{ display: 'flex', alignItems: 'center', flex: 1 }}
            menu={(close) => (
              <MCDatePicker
                minDate={minDate}
                maxDate={maxDate}
                onChange={(v) => {
                  onChange(name, v);
                  close();
                }}
                selected={gfg_Run(value || defaultCalendar, true)}
              />
            )}
          >
            {() => (
              <>
                <input
                  readOnly={true}
                  type='text'
                  name={name}
                  placeholder={lang.t(placeholder)}
                  id={'mc-' + name}
                  className={`mc-input-box ${invalid[name] ? 'invalid' : 'valid'}`}
                  value={gfg_Run(value, false, format) || ''}
                />
                {(!value || !close) && !noIcon && (
                  <SVGIcon
                    width={30}
                    iconname={BASE_ICONS.CALENDAR}
                    fill={scssVariables['colors-mc-text-primary']}
                  />
                )}
              </>
            )}
          </PopoverMenu>

          {!!value && close && (
            <span
              style={{
                position: 'absolute',
                display: 'flex',
                zIndex: 1,
                right: rightIcon || 10,
                cursor: 'pointer'
              }}
              onClick={() => {
                onChange(name, '');
              }}
            >
              <SVGIcon iconname={BASE_ICONS.CLOSE} width={20} />
            </span>
          )}
        </div>
        {invalid[name] && <p className='mc-form-invalid-text'>{invalid[name]}</p>}
      </div>
    );
  }
);
DatePickerField.displayName = 'DatePickerField';
export default DatePickerField;
